<template>
	<section :class="['sk-panel', { 'sk-panel--extra-padding': extra }]">
		<header class="sk-panel__header">
			<div class="sk-panel__header-item sk-panel__header-item-left"><slot name="header-left"></slot></div>
			<div v-if="hasHeaderRightSlot" :class="['sk-panel__header-item', 'sk-panel__header-item-right']"><slot name="header-right"></slot></div>
			<div @click="actionMenu" id="action-menu-toggle" class="sk-panel__action-menu">
				<span></span>
				<span></span>
			</div>
		</header>
		<main :class="['sk-panel__content', { 'sk-panel__content--no-padding-top': contentNoPaddingTop}]">
			<slot></slot>
		</main>
	</section>
</template>

<script>
export default {
	name: 'painel-shell',
	props: {
		extra: {
			type: Boolean,
			default: false
		},
		contentNoPaddingTop: {
			type: Boolean,
			default: false
		}
	},
	computed: {
		hasHeaderRightSlot() {
			return !!this.$slots['header-right']
		}
	},
	methods: {
		actionMenu() {
			this.$root.$emit('navigation-toggle', {})
		}
	}
}
</script>

<style scope>

.sk-panel {
	height: 100%;
	display: grid;
	grid-template-rows: var(--topbar-height) 1fr;
}

.sk-panel__header {
	background-color: var(--main-color-soft);
	display: grid;
	grid-template-columns: minmax(auto, 320px) 1fr;
	/* grid-template-columns: 1fr 1fr 1fr; */
	align-items: center;
}

.sk-panel__header-item {}

.sk-panel__header-item.sk-panel__header-item-left {
}

.sk-panel__header-item.sk-panel__header-item-center {
	justify-self: center;
}

.sk-panel__header-item.sk-panel__header-item-right {
	justify-self: flex-end;
}

.sk-panel__content {
	padding: 40px;
	overflow-y: auto;
	height: calc(100vh - var(--topbar-height));
	background-color: #fcfcfc;
}

.sk-panel__content.sk-panel__content--no-padding-top {
	padding-top: 0;
}

.sk-panel__action-menu {
	display: none;
	order: 2;
	width: 100%;
	height: 100%;
	background-color: var(--main-color-dark-2);
	position: relative;
	cursor: pointer;
}
.sk-panel__action-menu > span {
	display: block;
	width: 100%;
	height: 100%;
	position: absolute;
	background-position: center;
	background-repeat: no-repeat;
	transition: transform 0.3s, opacity 0.3s;
}
.sk-panel__action-menu:hover > span,
.sk-panel__action-menu:active > span {
	transform: scale(1.2, 1.2);
}
.sk-panel__action-menu > span:nth-child(1) {
	background-size: 24px;
	background-image: url(/static/svg/buttons/menu.svg);
	opacity: 1;
}
.sk-panel__action-menu > span:nth-child(2) {
	background-size: 18px;
	background-image: url(/static/svg/buttons/close.svg);
	opacity: 0;
}
.sk--active .sk-panel__action-menu  > span:nth-child(1) {
	opacity: 0;
}
.sk--active .sk-panel__action-menu  > span:nth-child(2) {
	opacity: 1;
}
@media screen and (max-width: 900px) {
	.sk-panel--extra-padding .sk-panel__content {
		padding: 70px 20px 75px 20px;
	}
	.sk-panel__header-item.sk-panel__header-item-right {
		position: absolute;
		top: 75px;
		left: 250px;
		right: 0;
		background-color: var(--main-color-bg-t-4);
		height: 50px;
		display: flex;
		align-items: center;
		justify-content: center;
		z-index: 500;
		border-bottom: 1px solid #f0f0f0;
	}
}
@media screen and (max-width: 768px) {
	.sk-panel__action-menu {
		display: block;
	}
	.sk-panel__header {
		grid-template-columns: 1fr 75px;
	}
	.sk-panel__content {
		padding: 40px 20px 75px 20px;
	}
	.sk-panel__header-item.sk-panel__header-item-right {
		left: 0;
	}
}
</style>



// WEBPACK FOOTER //
// src/modules/shell/PainelShell.vue